module.exports = __webpack_public_path__ + "img/firefox_step_5.84911f20.jpg";